module.exports = __webpack_public_path__ + "media/images/athletes/2808-55a3e0ebb8ffcb0d8b5f4f07c4452c48.png";